import React, { useState, useEffect } from "react";
import { Link, Redirect, useParams,useNavigate } from "react-router-dom";
import { api } from '../../services/api.js';
import Menu from "../../comum/Menu/index.jsx";
import './index.css';
import Footer from "../../comum/Footer/index.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import { AuthContext } from '../../comum/Context/auth.jsx';

function SapSol() {

    const [dia, setDia] = useState(0);
    const [dia_semana, setDiaSemana] = useState('');
    const [parametro, setParametro] = useState('');
    const [abertura, setAbertura] = useState('');
    const [fechamento, setFechamento] = useState('');
    const [sucesso, setSucesso] = useState('');
    const [lista_horario, setListaHorario] = useState([]);
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate()

    useEffect(() => {
        const chapa = localStorage.getItem("chapa");
        if (!chapa) {
            navigate("/arbor/login"); // Redireciona se não for funcionário logado
        }
    }, []);

    function CarregarDadosHorario() {
        // Editar...
        api.get('/SAP/horario/' + chapa)
            .then(retorno => {
                setListaHorario(retorno.data);
                console.log(retorno.data)
            })
            .catch(err => {
                console.log(err);
            });
    }


    function handleAberturaChange(abertura, index) {
        const loc = [...lista_horario];
        loc[index].abertura = abertura;
        setListaHorario(loc);
    }

    function handleFechamentoChange(fechamento, index) {
        const loc = [...lista_horario];
        loc[index].fechamento = fechamento;
        setListaHorario(loc);
    }

    function AlterarHorario(parametro, abertura, fechamento) {
        console.log(parametro + '  ' + abertura + '  ' + fechamento)
        api.post('/SAP/horario?param=' + parametro + '&abertura=' + abertura + '&fechamento=' + fechamento)
            .then((retorno) => {
                CarregarDadosHorario();
                setSucesso('OK');
            })
            .catch((err) => {
                console.log(err);
            });
    }

    useEffect(() => {
        CarregarDadosHorario();
    }, []);

    return <>
        <Menu />
        <div className="container-fluid form-card-cadastro">
            <div className="row col-lg-6 offset-lg-3">
                <div className="col-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Dia</th>
                                <th scope="col">Semana</th>
                                <th scope="col">Abertura </th>
                                <th scope="col">Fechamento </th>
                                <th scope="col">Alterar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                lista_horario.map((horario, index) => {
                                    return <tr key={horario.dia}>
                                        <td>
                                            <input type="number"
                                                className="form-control"
                                                value={horario.dia}
                                                placeholder="Dia" disabled />
                                        </td>
                                        <td><input type="text" value={horario.diasemana}
                                            className="form-control"
                                            placeholder="Dia da semana" disabled />
                                        </td>
                                        <td><input type="time" value={horario.abertura}
                                            onChange={(e) => handleAberturaChange(e.target.value, index)}
                                            className="form-control"
                                            placeholder="Abertura"
                                            maxLength="5"
                                            mask="99:99" />
                                        </td>
                                        <td><input type="time" value={horario.fechamento}
                                            onChange={(e) => handleFechamentoChange(e.target.value, index)}
                                            inputmode="numeric"
                                            name="fechamento"
                                            className="form-control"
                                            placeholder="Fechamento"
                                            maxLength="5"
                                            mask="99:99"
                                            pattern="[0-9]{2}:[0-9]{2}" />
                                        </td>
                                        <td><button type="button" onClick={(e) => AlterarHorario(horario.parametro, horario.abertura, horario.fechamento)} className="btn btn-success">
                                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                        </td>

                                    </tr>
                                })
                            }
                        </tbody>
                    </table>

                    {
                        lista_horario.length == 0 ?
                            <div className="no-item">Nenhum horário encontrado</div>
                            : null
                    }

                </div>

                <div className="col-md-12 ">
                    {/*  <button type="button" className="btn btn-sm btn-primary" onClick={AdicionarSetor} >Adicionar Setor</button>  */}
                </div>


                <div className="col-12 mt-3">
                    {/*
                        msg.length > 0 ? <div className="alert alert-danger mt-4 text-center">{msg}</div> : null
                    */}
                    <div>
                        <div className="d-flex justify-content-end">
                            <Link to={"/arbor/sap/"} type="button" className="btn btn-outline-primary me-4">Voltar</Link>
                            {/* <button type="button" className="btn btn-outline-primary me-4"> Salvar Dados</button> onClick={SalvarDados}>*/}
                        </div>
                    </div>
                </div>

            </div>

            {
                sucesso === '' ?
                    null
                    :
                    <SweetAlert
                        success
                        showCloseButton
                        confirmBtnText="OK"
                        confirmBtnBsStyle="danger"
                        onConfirm={() => setSucesso('')}
                        title="Sucesso"
                        reverseButtons={false}
                        openAnim={{ name: 'showSweetAlert', duration: 2000 }}
                        closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
                    >   Gravação efetuada com sucesso!
                    </SweetAlert>
            }


        </div>
        <Footer />
    </>
}

export default SapSol;

